export default __webpack_public_path__ + "static/media/Group 8706_7.9a772246.png";